module.exports = __webpack_public_path__ + "img/Google-play.8a72e06c.png";